import { createSelector } from 'reselect'
import { userRetailerAccountsSelector } from '../retailer-accounts/selectors'
import inflection from 'inflection'

const brandSelector = (state) => (state.brands && state.brands.brand) || null
const brandsSelector = (state) => (state.brands && state.brands.brands) || null
const brandErrorSelector = (state) =>
  (state.brands && state.brands.error) || null

export const brandsByRetailerAccountSelector = createSelector(
  [userRetailerAccountsSelector],
  (retailerAccounts) => {
    return retailerAccounts.reduce((map, retailerAccount) => {
      const retailers = retailerAccount.retailers || []
      map[retailerAccount.id] = retailers.map((retailer) => {
        return retailer.brand
      })
      return map
    }, {})
  },
)

export const currentScopedBrand = createSelector(
  [brandSelector],
  (brand) => {
    return { brand }
  },
)

export const selectFormattedBrandRetailerAlias = createSelector(
  [brandSelector],
  (brand) => {
    return { retailerAlias: inflection.titleize(brand.retailer_alias) }
  },
)

export const selectFormattedPluralBrandRetailerAlias = createSelector(
  [brandSelector],
  (brand) => {
    return {
      retailerAliasPlural: inflection.pluralize(
        inflection.titleize(brand.retailer_alias),
      ),
    }
  },
)

export const scopedBrandFailed = createSelector(
  [brandErrorSelector],
  (error) => {
    return {
      scopedBrandFailed: error !== null,
    }
  },
)

export const scopedBrandIsValid = createSelector(
  [brandSelector],
  (brand) => {
    return {
      scopedBrandValid: brand !== null,
    }
  },
)

export const selectBrands = createSelector(
  [brandsSelector],
  (brands) => {
    return { brands }
  },
)

export const selectBrandsPresent = createSelector(
  [brandsSelector],
  (brands) => {
    return { brandsPresent: brands && brands.length > 0 }
  },
)
